export default __webpack_public_path__ + "static/media/Slider-1.bf4906ee.png";